<template>
  <v-container class="input-text-size">
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-3 ma-3 pa-3">
          <upload-form @upload-queued="onUploadQueued" />
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-3 ma-3 pa-3">
          <queue-table
            ref="queueTable"
            @view-records="onViewRecords"
          />
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="selectedImportData" ref="detailsSection">
      <v-col cols="12">
        <v-card class="elevation-3 ma-3 pa-3">
          <records-table
            :import-data="selectedImportData"
            @close="selectedImportData = null"
            @update-record-status="onUpdateRecordStatus"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import UploadForm from '@/components/tax/MortgageCoProcessing/MortgagePaymentUploadForm.vue';
import QueueTable from '@/components/tax/MortgageCoProcessing/MortgagePaymentQueueTable.vue';
import RecordsTable from '@/components/tax/MortgageCoProcessing/MortgagePaymentRecordsTable.vue';

export default {
  name: 'MortgageCompanyPayments',
  components: {
    UploadForm,
    QueueTable,
    RecordsTable,
  },
  data() {
    return {
      selectedImportData: null,
    };
  },
  methods: {
    ...mapActions('mortgagePaymentImport', [
      'loadMortgagePaymentImport',
    ]),
    onUploadQueued() {
      // Refresh the queue table when a new upload is queued
      if (this.$refs.queueTable) {
        this.$refs.queueTable.loadQueue();
      }
    },
    async onViewRecords(queueItem) {
      try {
        // Load the import data with records
        const result = await this.loadMortgagePaymentImport({
          criteria: {
            fileQueueId: queueItem._id,
          },
          fields: {
            _id: 1,
            fileQueueId: 1,
            mortgageCompany: 1,
            postingDate: 1,
            totalRecords: 1,
            validRecords: 1,
            overpaymentRecords: 1,
            underpaymentRecords: 1,
            notFoundRecords: 1,
            totalOverpaymentAmount: 1,
            totalUnderpaymentAmount: 1,
            paymentApplied: 1,
            records: {
              taxYear: 1,
              taxId: 1,
              propertyOrParcelId: 1,
              mtgCode: 1,
              nameFromMtgComp: 1,
              loanNumber: 1,
              paymentAmount: 1,
              expectedAmount: 1,
              calculatedPenalty: 1,
              amountDifference: 1,
              validationStatus: 1,
              errorDescription: 1,
              statusCode: 1,
            },
          },
        });

        if (result && result.length > 0) {
          const importData = result[0];
          // Add originalIndex to each record for identification
          if (importData.records) {
            importData.records = importData.records.map((record, index) => ({
              ...record,
              originalIndex: index,
            }));
          }
          this.selectedImportData = importData;

          // Scroll to details section after DOM updates
          this.$nextTick(() => {
            const element = this.$refs.detailsSection;
            if (element) {
              // Check if it's a Vue component or native element
              const scrollTarget = element.$el || element;
              scrollTarget.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading import records:', error);
      }
    },
    onUpdateRecordStatus({ recordIndex, newStatus }) {
      // Update the record status in the local data
      if (this.selectedImportData && this.selectedImportData.records) {
        const record = this.selectedImportData.records.find(
          (r) => r.originalIndex === recordIndex,
        );
        if (record) {
          record.validationStatus = newStatus;
          record.errorDescription = null;
        }
      }
    },
  },
};
</script>

<style scoped>
</style>
